// extracted by mini-css-extract-plugin
export default {"container":"styles_container__xmQ8A","htmlgenerated":"styles_htmlgenerated__9jGkU"};